import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import cuid from 'cuid';
import Footer from '@empiriecom/module-inspire-components/components/Footer';
import { FontSizes } from '@empiriecom/module-inspire-components/utils/style.drupal';
import { trackingProvider } from '@empiriecom/module-inspire-components/providers/trackingProvider';
import { DataGlobal } from '@empiriecom/module-inspire-components/interfaces/cmsdata';

const StyledPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center; /* horizontal alignment */
  align-items: center; /* vertical alignment */
  text-align: left;
  ${FontSizes()}
`;

const PageContainer: FunctionComponent<{
  data?: DataGlobal;
  onlySocket: boolean;
  clusterType?: string;
}> = ({ data, onlySocket }): JSX.Element => {
  const cmsData = data || { field_pagegroup: 'missing' };

  const itemID = cuid();

  const ElementPageContent = (): JSX.Element =>
    cmsData && cmsData?.paragraph ? (
      <Footer footerData={cmsData.paragraph} key={itemID} onlySocket={!!onlySocket} />
    ) : (
      <></>
    );

  if (cmsData?.field_page_landmark) {
    trackingProvider.setLandmark({
      landmarkName: 'emma',
      template: cmsData.field_page_landmark,
    });
  }

  if (cmsData) {
    return (
      <>
        <StyledPageContainer className="page-container" data-testid="page-container">
          <ElementPageContent />
        </StyledPageContainer>
      </>
    );
  }
  return <></>;
};

export default PageContainer;
